/** Settings → Plugins → Browse: every bundled package, marked when installed. */
import { PocketRow, PocketSection } from "@/components/ui";
import { Icons } from "@/components/ui/icons";
import { useT } from "@/i18n";
import { settingsPluginsMessages } from "@/i18n/messages/settings-plugins";
import { usePluginCatalog } from "./plugins-state";
import { SettingsLoadStatus } from "./settings-load-status";
import { useSettingsNav } from "./settings-navigation";

export function PluginsBrowsePage() {
  const t = useT(settingsPluginsMessages);
  const nav = useSettingsNav();
  const catalog = usePluginCatalog();
  const settled = !catalog.loading && !catalog.error;
  return (
    <div data-testid="settings-page-plugins-browse">
      <SettingsLoadStatus
        state={catalog}
        noun={t("pluginsNoun")}
        retryTestId="plugins-catalog-retry"
      />
      {settled && !catalog.data.length && (
        <p className="px-2 py-1 text-appkit-small text-muted">
          {t("noPluginsAvailable")}
        </p>
      )}
      {catalog.data.length > 0 && (
        <PocketSection testId="plugins-catalog">
          {catalog.data.map((item) => (
            <PocketRow
              key={`${item.slug}@${item.version}`}
              testId={`plugins-catalog-${item.slug}`}
              leading={<Icons.Package className="h-4 w-4 text-muted" />}
              title={item.name}
              // A catalog's descriptions: two lines each, where settings wrap.
              secondLine={
                <span className="line-clamp-2">{item.description}</span>
              }
              trailing={item.installed ? t("installed") : undefined}
              chevron
              onSelect={() =>
                nav.push({
                  page: "plugins-plugin",
                  args: {
                    slug: item.slug,
                    version: item.version,
                    title: item.name,
                  },
                })
              }
            />
          ))}
        </PocketSection>
      )}
    </div>
  );
}
